import React from 'react';
import { Marker } from '@react-google-maps/api';
import { redMarker, blueMarker } from './constants';

const RepairFinderMarker = ({
  dealership, map, selectedDealershipId, setSelectedDealershipId,
}) => {
  const position = {
    lat: parseFloat(dealership.attributes.lat),
    lng: parseFloat(dealership.attributes.lng),
  };

  return (
    <Marker
      position={position}
      onClick={() => {
        map.panTo(position);
        setSelectedDealershipId(parseInt(dealership.id, 10));
      }}
      icon={selectedDealershipId === parseInt(dealership.id, 10) ? blueMarker : redMarker}
    />
  );
};

export default RepairFinderMarker;
